<template>
  <div class="min-height">
    <TableLoading v-if="branches.page === 0"/>
    <div v-else>
      <form @submit.prevent="SalesProfileAction">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>Select Customer</label>
            <multiselect v-model="profile.customer" :options="branches.objects"
                         class="multiselect-height-3" placeholder="Select one" label="name" track-by="name" :searchable="true" :internal-search="false" @search-change="asyncFindCustomer">
              <span slot="noResult">No customer found. Change search query.</span>
            </multiselect>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Select Status</label>
            <multiselect v-model="profile.status" :options="statuses.objects" :class="{
                            'is-invalid': v$.profile.status.$error,
                      }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
            <p
                v-for="error in v$.profile.status.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Customer (incase it is a new customer)</label>
            <input
                v-model="profile.name"
                name="name"
                type="text"
                class="form-control py-3"
            />
          </div>
          <div class="col-sm-6 mb-3">
            <label>Customer Area Zone</label>
            <multiselect v-model="profile.zone" :options="zones.objects" :class="{
                            'is-invalid': v$.profile.zone.$error,
                      }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
            <p
                v-for="error in v$.profile.zone.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Select Products of Interest</label>
            <multiselect v-model="profile.productsOfInterest" :options="products.objects" :class="{'is-invalid': v$.profile.productsOfInterest.$error}"
                         class="multiselect-height-3" placeholder="Select one" label="productName" track-by="productName" :multiple="true" :searchable="true" :internal-search="false" @search-change="asyncFindProduct">
              <span slot="noResult">No product found. Change search query.</span>
            </multiselect>
            <p
                v-for="error in v$.profile.productsOfInterest.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Enter Suppliers (Ensure to comma separate the brand names)</label>
            <input
                v-model="profile.suppliers"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.profile.suppliers.$error,
                      }"
            />
            <p
                v-for="error of v$.profile.suppliers.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Enter Restaurant Capacity</label>
            <input
                v-model="profile.capacity"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.profile.capacity.$error,
                      }"
            />
            <p
                v-for="error of v$.profile.capacity.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Enter Soy Sauce Brands (Ensure to comma separate the brand names)</label>
            <input
                v-model="profile.brands"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.profile.brands.$error,
                      }"
            />
            <p
                v-for="error of v$.profile.brands.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Enter Monthly Consumption (Soy Sauce) Litres</label>
            <input
                v-model="profile.monthlyConsumption"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.profile.monthlyConsumption.$error,
                      }"
            />
            <p
                v-for="error of v$.profile.monthlyConsumption.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Current Supplier Complaint</label>
            <textarea
                v-model="profile.supplierComplaints"
                name="name"
                type="text"
                rows="6"
                class="form-control py-3"
            ></textarea>
          </div>
          <div class="row mt-5"  v-for="(p, r) in profile.personsInCharge"
               :key="r">
            <div class="mb-3 col-sm-2">
              <label>Title</label>
              <input
                  v-model="profile.personsInCharge[r].title"
                  type="text"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-2">
              <label>Name</label>
              <input
                  v-model="profile.personsInCharge[r].name"
                  type="text"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-3">
              <label>Phone Number</label>
              <input
                  v-model="profile.personsInCharge[r].tel"
                  type="number"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-3">
              <label>Email</label>
              <input
                  v-model="profile.personsInCharge[r].email"
                  type="email"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-2 form-group align-self-end">
              <button
                  class="btn rounded-circle btn-info mx-2"
                  v-if="r > 0"
                  @click.prevent="removeContact(profile.personsInCharge, r)"
              >
                <i class="bx bx-minus"></i>
              </button>
              <button
                  class="btn rounded-circle btn-success mx-2"
                  v-if="r == profile.personsInCharge.length - 1"
                  @click.prevent="addContact(profile.personsInCharge)"
              >
                <i class="bx bx-plus"></i>
              </button>
            </div>
          </div>
          <div class="col-sm-6 mt-5 mb-3">
            <label>Feedback Information</label>
            <ckeditor v-model="profile.feedbackData" :editor="editor" :class="{
                        'is-invalid': v$.profile.feedbackData.$error,
                      }"></ckeditor>
            <p
                v-for="error of v$.profile.feedbackData.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <div class="mt-3 col-12">
            <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="customerLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
              {{ button_text }}
            </b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import CKEditor from "@ckeditor/ckeditor5-vue";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ALL_CUSTOMER_BRANCHES, ALL_SALES_PROFILE_STATUS} from "@/gql/customers";
import {ALL_DELIVERY_ZONES} from "@/gql/system-settings";
import {ALL_PRODUCTS_SIMPLE} from "@/gql/stock";
import {mapGetters} from "vuex";
import TableLoading from "@/components/TableLoading";

export default {
name: "sales-profile-form",
  components: {TableLoading, Multiselect, ckeditor: CKEditor.component},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      profile: this.selected_profile,
      productSearchKeyword: "",
      customerSearchKeyword: '',
      editor: ClassicEditor,
      branches: {
        page: 0,
        objects: []
      },
      zones: {
        objects: []
      },
      statuses: {
        objects: []
      },
      products: {
        objects: []
      },
    }
  },
  validations () {
    return {
      profile: {
        status: {required},
        zone: {required},
        productsOfInterest: {required},
        suppliers: {required},
        capacity: {required},
        brands: {required},
        monthlyConsumption: {required},
        feedbackData: {required},
      }
    }
  },
  apollo: {
    branches: {
      query: ALL_CUSTOMER_BRANCHES,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.customerSearchKeyword
        }
      }
    },
    statuses: {
      query: ALL_SALES_PROFILE_STATUS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    },
    zones: {
      query: ALL_DELIVERY_ZONES,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    },
    products: {
      query: ALL_PRODUCTS_SIMPLE,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.productSearchKeyword
        }
      }
    }
  },
  props: {
    selected_profile: {
      type: Object,
      default(){
        return {
          customer:"",
          status:"",
          name:"",
          zone:"",
          productsOfInterest:"",
          suppliers:"",
          supplierComplaints: "",
          capacity:"",
          brands:"",
          monthlyConsumption:"",
          feedbackData:"",
          personsInCharge: [{ title: "", name: "" , tel: "", email: ""}]
        }
      }
    },
    button_text: {type: String}
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  methods:{
    async SalesProfileAction() {
      // const isFormCorrect = await this.v$.$validate()
      // if (!isFormCorrect) {
      //   return
      // }

      const product_ids = []
      this.profile.productsOfInterest.forEach((product) => {
        product_ids.push(product.publicId)
      })

      const data = {
        ...this.profile,
        customer: this.profile.customer?.publicId,
        zone: this.profile.zone?.publicId,
        status: this.profile.status?.publicId,
        productsOfInterest: product_ids,
        suppliers: this.profile.suppliers.split(','),
        brands: this.profile.brands.split(','),
        capacity: parseFloat(this.profile.capacity)
      }
      this.$emit('SalesProfileAction', data)
      this.v$.$touch();
    },
    removeContact(p, i) {
      p.splice(i, 1);
    },
    addContact(p) {
      p.push({ title: "", name: "" , phone: "", email: ""});
    },
    asyncFindProduct (query) {
      this.productSearchKeyword = query
    },
    asyncFindCustomer(query) {
      this.customerSearchKeyword = query
    }
  }
}
</script>

<style scoped>

</style>
